/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserGroupSortCriteria {
    getFixupPrototypeFunction() { return UserGroupSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<UserGroupSortCriteria>): UserGroupSortCriteria {
        let obj = Object.assign(new UserGroupSortCriteria(), model);
        UserGroupSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserGroupSortCriteria>): UserGroupSortCriteria {
        if (!model) return null;
        return UserGroupSortCriteria.newInstance(<UserGroupSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserGroupSortCriteria) {
        if (!obj) return;

        models.UserGroupSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserGroupSortCriteria): boolean {
        Object.setPrototypeOf(obj, UserGroupSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.UserGroupSortColumn;

    ascending: boolean;

}
